<template>
  <v-dialog v-model="dialogVisible" :max-width="dialogWidth" max-height="auto">
    <v-card>
      <v-card-title><span class="text-h6">Update Keyword</span>
        <span class="name_topic">Topic: {{ name_topic_dialog }}</span> </v-card-title>
      <v-card-text>
        <div class="keyword-list">
          <div class="keyword-row keyword-row--head" :style="gridStyle">
            <div class="keyword-cell keyword-cell--keyword"></div>
            <div
              class="keyword-cell keyword-cell--head"
              v-for="col in activeCollections"
              :key="'head-' + col.key"
            >
              <v-icon small :title="col.label">{{ col.icon }}</v-icon>
            </div>
            <div class="keyword-cell keyword-cell--head"></div>
          </div>

          <div
            class="keyword-row"
            :style="gridStyle"
            v-for="(item, index) in item_edit_keyword_dinamis"
            :key="index"
          >
            <div class="keyword-cell keyword-cell--keyword">
              <v-text-field
                outlined
                dense
                hide-details
                v-model="item.keywordname"
                label="Keywords"
                :disabled="keywordstatus === 0"
              ></v-text-field>
            </div>

            <div
              class="keyword-cell"
              v-for="col in activeCollections"
              :key="col.key"
            >
              <v-btn
                class="elevation-0 keyword-check"
                outlined
                icon
                color="#0471A5"
                @click="$emit('toggle-collection', item, index, col.key)"
              >
                <v-icon :color="isChecked(item, col.checkKey) ? '#0471A5' : '#B0BEC5'">
                  {{ isChecked(item, col.checkKey) ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-blank-circle-outline' }}
                </v-icon>
              </v-btn>
            </div>

            <div class="keyword-cell">
              <v-btn
                class="elevation-0 keyword-check"
                :class="{
                  'red darken-1': keywordstatus !== 0,
                  'grey darken-1': keywordstatus === 0
                }"
                :color="keywordstatus === 0 ? '#fff' : '#fff'"
                icon
                @click="keywordstatus !== 0 && $emit('remove-keyword', item, index)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </div>

          <v-btn
            v-show="buttonAddKeyword"
            :color="keywordstatus === 0 ? 'grey' : 'blue darken-1'"
            class="keyword-add mt-3"
            rounded
            dark
            dense
            @click="keywordstatus === 0 ? '' : $emit('add-keyword')"
          >
            <v-icon>mdi-plus</v-icon> Add Keywords
          </v-btn>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
          Cancel
        </v-btn>
        <v-btn v-show="keywordstatus !== 0"  color="blue darken-1" style="width: 90px;" rounded dark dense @click="$emit('save')">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    item_edit_keyword_dinamis: { type: Array, default: () => [] },
    keywordstatus: { type: Number, default: 1 },
    name_topic_dialog: { type: String, default: '' },
    width_form_keyword: { type: String, default: '400px' },
    collect_news_val: { type: Boolean, default: false },
    collect_twit_val: { type: Boolean, default: false },
    collect_ytb_val: { type: Boolean, default: false },
    collect_tiktok_val: { type: Boolean, default: false },
    collect_ig_val: { type: Boolean, default: false },
    collect_fb_val: { type: Boolean, default: false },
    buttonAddKeyword: { type: Boolean, default: true }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    activeCollections() {
      const list = []
      if (this.collect_news_val) list.push({ key: 'NEWS', checkKey: 'checknews', icon: 'mdi-web', label: 'News' })
      if (this.collect_twit_val) list.push({ key: 'TWITTER', checkKey: 'checktwet', icon: 'mdi-twitter', label: 'Twitter' })
      if (this.collect_ytb_val) list.push({ key: 'YOUTUBE', checkKey: 'checkytb', icon: 'mdi-youtube', label: 'YouTube' })
      if (this.collect_tiktok_val) list.push({ key: 'TIKTOK', checkKey: 'checktiktok', icon: 'fa-brands fa-tiktok', label: 'TikTok' })
      if (this.collect_ig_val) list.push({ key: 'INSTAGRAM', checkKey: 'checkig', icon: 'mdi-instagram', label: 'Instagram' })
      if (this.collect_fb_val) list.push({ key: 'FACEBOOK', checkKey: 'checkfb', icon: 'mdi-facebook', label: 'Facebook' })
      return list
    },
    gridColumns() {
      const columns = ['minmax(0, 1fr)']
      this.activeCollections.forEach(() => columns.push('44px'))
      columns.push('44px')
      return columns.join(' ')
    },
    gridStyle() {
      return { gridTemplateColumns: this.gridColumns }
    },
    dialogWidth() {
      const count = this.activeCollections.length
      const minWidth = 272 + (count + 1) * 52
      const propWidth = parseInt(this.width_form_keyword, 10) || 400
      return Math.max(propWidth, minWidth) + 'px'
    }
  },
  methods: {
    isChecked(item, key) {
      return item[key] == true
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.keyword-list {
  width: 100%;
}

.keyword-row {
  display: grid;
  align-items: center;
  column-gap: 6px;
  margin-bottom: 4px;
}

.keyword-row--head {
  min-height: 32px;
  margin-bottom: 2px;
}

.keyword-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.keyword-cell--keyword {
  display: block;
  min-width: 240px;
  padding-right: 8px;
}

.keyword-cell--head {
  color: rgba(0, 0, 0, 0.6);
}

.keyword-check {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
}

.keyword-add {
  width: 160px;
}
</style>
